/* Komfort: skrypt motywu (bez zależności zewnętrznych) */
(() => {
  'use strict';

  const T = window.theme;
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const formatMoney = (cents) =>
    new Intl.NumberFormat(T.locale, { style: 'currency', currency: T.currency }).format(cents / 100);

  /* ---------------------------------------------------------------------- *
   * Pasek ogłoszeń: rotacja komunikatów
   * ---------------------------------------------------------------------- */
  const initAnnouncement = () => {
    const msgs = $$('.announcement__msg');
    if (msgs.length < 2) return;
    let i = 0;
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4500);
  };

  /* ---------------------------------------------------------------------- *
   * Menu mobilne i wyszukiwarka
   * ---------------------------------------------------------------------- */
  const setMenu = (open) => {
    const menu = $('[data-mobile-menu]');
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    $$('[data-menu-toggle][aria-expanded]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
    document.body.classList.toggle('no-scroll', open);
  };

  const toggleSearch = () => {
    const panel = $('[data-search-panel]');
    if (!panel) return;
    const open = panel.hidden;
    panel.hidden = !open;
    $$('[data-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
    if (open) $('[data-search-input]', panel)?.focus();
  };

  /* ---------------------------------------------------------------------- *
   * Koszyk
   * ---------------------------------------------------------------------- */
  const drawer = () => $('[data-cart-drawer]');

  const setDrawer = (open) => {
    const el = drawer();
    if (!el) return;
    el.classList.toggle('is-open', open);
    el.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('no-scroll', open);
  };

  const setCartCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };

  const renderDrawer = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = $('[data-cart-drawer-content]', doc);
    const current = $('[data-cart-drawer-content]', document);
    if (next && current) current.replaceWith(next);
  };

  const changeLine = async (line, quantity, inDrawer) => {
    const body = { line, quantity };
    if (inDrawer) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;
    }
    const res = await fetch(T.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const cart = await res.json();
    if (!res.ok) throw new Error(cart.message || T.strings.error);
    if (inDrawer) {
      setCartCount(cart.item_count);
      renderDrawer(cart.sections && cart.sections['cart-drawer']);
    } else {
      window.location.reload();
    }
  };

  const onCartClick = (event) => {
    const target = event.target;

    const toggle = target.closest('[data-cart-toggle]');
    if (toggle && T.cartType === 'drawer' && drawer()) {
      event.preventDefault();
      setDrawer(true);
      return true;
    }

    if (target.closest('[data-close-cart]')) {
      setDrawer(false);
      return true;
    }

    const qtyBtn = target.closest('[data-cart-qty]');
    if (qtyBtn) {
      const line = Number(qtyBtn.dataset.line);
      const input = $(`[data-cart-input][data-line="${line}"]`, qtyBtn.closest('form'));
      const next = Math.max(0, Number(input.value) + Number(qtyBtn.dataset.cartQty));
      changeLine(line, next, !!qtyBtn.closest('[data-cart-drawer]')).catch(() => alert(T.strings.error));
      return true;
    }

    const removeLink = target.closest('[data-cart-remove]');
    if (removeLink) {
      event.preventDefault();
      changeLine(Number(removeLink.dataset.line), 0, !!removeLink.closest('[data-cart-drawer]')).catch(() =>
        alert(T.strings.error)
      );
      return true;
    }
    return false;
  };

  const onCartInputChange = (event) => {
    const input = event.target.closest('[data-cart-input]');
    if (!input) return;
    const qty = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine(Number(input.dataset.line), qty, !!input.closest('[data-cart-drawer]')).catch(() =>
      alert(T.strings.error)
    );
  };

  /* ---------------------------------------------------------------------- *
   * Produkt: warianty, zestawy, ilość, galeria, dodawanie do koszyka
   * ---------------------------------------------------------------------- */
  const initProduct = (root) => {
    const variantsEl = $('[data-variants]', root);
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    const idInput = $('[data-variant-id]', root);
    const qtyHidden = $('[data-qty-hidden]', root);
    const qtyInput = $('[data-qty-input]', root);
    const form = $('form.product-form', root);
    /* Zakup od razu: po dodaniu przechodzimy do kasy zamiast do koszyka */
    const directCheckout = $('[data-direct-checkout]', root);
    const atcText = (directCheckout && directCheckout.dataset.directCheckout) || T.strings.addToCart;
    const updateUrl = root.dataset.updateUrl === 'true';
    let current = variants.find((v) => idInput && String(v.id) === idInput.value) || variants[0];

    const setQty = (qty) => {
      qty = Math.max(1, qty);
      if (qtyHidden) qtyHidden.value = qty;
      if (qtyInput) qtyInput.value = qty;
    };

    /* Ilość (stepper) */
    $('[data-qty-minus]', root)?.addEventListener('click', () => setQty((parseInt(qtyInput.value, 10) || 1) - 1));
    $('[data-qty-plus]', root)?.addEventListener('click', () => setQty((parseInt(qtyInput.value, 10) || 1) + 1));
    qtyInput?.addEventListener('change', () => setQty(parseInt(qtyInput.value, 10) || 1));

    /* Zestawy ilościowe */
    const updateBundlePrices = () => {
      if (!current) return;
      $$('[data-bundle]', root).forEach((radio) => {
        const qty = Number(radio.dataset.qty);
        const pct = Number(radio.dataset.percent);
        const total = Math.floor((current.price * qty * (100 - pct)) / 100);
        const label = radio.closest('.bundle').querySelector('[data-bundle-price]');
        if (label) label.textContent = formatMoney(total);
      });
    };
    $$('[data-bundle]', root).forEach((radio) =>
      radio.addEventListener('change', () => radio.checked && setQty(Number(radio.dataset.qty)))
    );

    /* Galeria */
    const track = $('[data-gallery-track]', root);
    const thumbs = $$('[data-thumb]', root);
    const goToSlide = (index) => {
      const slide = track && track.children[index];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => goToSlide(Number(t.dataset.thumb))));
    if (track && thumbs.length) {
      track.addEventListener(
        'scroll',
        () => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
        },
        { passive: true }
      );
    }

    /* Stan magazynowy (prawdziwe dane z Shopify) */
    const stock = $('[data-stock]', root);
    const updateStock = () => {
      if (!stock || !current) return;
      const map = JSON.parse(stock.dataset.stockMap || '{}');
      const qty = map[current.id];
      const threshold = Number(stock.dataset.threshold);
      if (typeof qty === 'number' && qty > 0 && qty <= threshold) {
        $('[data-stock-text]', stock).textContent = T.strings.stockLeft.replace('[n]', qty);
        stock.hidden = false;
      } else {
        stock.hidden = true;
      }
    };

    /* Wybór wariantu */
    const updateVariantUI = () => {
      if (!current) return;
      if (idInput) idInput.value = current.id;

      $$('[data-price-current]', root).forEach((el) => (el.textContent = formatMoney(current.price)));
      const onSale = current.compare_at_price && current.compare_at_price > current.price;
      $$('[data-price-compare]', root).forEach((el) => {
        el.hidden = !onSale;
        if (onSale) el.textContent = formatMoney(current.compare_at_price);
      });
      $$('[data-price-badge]', root).forEach((el) => {
        el.hidden = !onSale;
        if (onSale) el.textContent = `-${Math.round(((current.compare_at_price - current.price) * 100) / current.compare_at_price)}%`;
      });
      $$('[data-price]', root).forEach((el) => el.classList.toggle('price--sale', !!onSale));

      const label = current.available
        ? atcText
        : current.missing
          ? T.strings.unavailable
          : T.strings.soldOut;
      $$('[data-atc-label]', root).forEach((el) => (el.textContent = label));
      $$('[data-atc-main], [data-atc-sticky]', root).forEach((btn) => (btn.disabled = !current.available));

      updateBundlePrices();
      updateStock();

      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url);
      }

      const mediaId = current.featured_media && current.featured_media.id;
      if (mediaId && track) {
        const index = Array.from(track.children).findIndex((s) => Number(s.dataset.mediaId) === mediaId);
        if (index >= 0) goToSlide(index);
      }
    };

    const optionInputs = $$('.variants__input', root);
    optionInputs.forEach((input) =>
      input.addEventListener('change', () => {
        const groups = $$('.variants__group', root);
        const selected = groups.map((g) => {
          const checked = $('.variants__input:checked', g);
          return checked ? checked.value : null;
        });
        groups.forEach((g, i) => {
          const lbl = $('[data-option-label]', g);
          if (lbl) lbl.textContent = selected[i];
        });
        const match = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        if (match) {
          current = match;
        } else {
          current = { ...current, available: false, missing: true };
        }
        updateVariantUI();
      })
    );

    updateStock();

    /* Dodawanie do koszyka (AJAX) */
    if (form) {
      form.addEventListener('submit', async (event) => {
        if (!window.fetch) return;
        event.preventDefault();
        const errorBox = $('[data-form-error]', form);
        const buttons = $$('[data-atc-main], [data-atc-sticky]', root);
        errorBox.hidden = true;
        buttons.forEach((b) => b.classList.add('is-loading'));

        const data = new FormData(form);
        data.append('sections', 'cart-drawer');
        data.append('sections_url', window.location.pathname);

        try {
          const res = await fetch(T.routes.cartAdd, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: data,
          });
          const json = await res.json();
          if (!res.ok || json.status) {
            throw new Error(json.description || json.message || T.strings.error);
          }
          if (directCheckout) {
            window.location.href = '/checkout';
            return;
          }
          if (T.cartType === 'drawer' && drawer()) {
            renderDrawer(json.sections && json.sections['cart-drawer']);
            const cart = await fetch(T.routes.cartJs).then((r) => r.json());
            setCartCount(cart.item_count);
            setDrawer(true);
          } else {
            window.location.href = T.routes.cart;
          }
        } catch (err) {
          errorBox.textContent = err.message || T.strings.error;
          errorBox.hidden = false;
        } finally {
          buttons.forEach((b) => b.classList.remove('is-loading'));
        }
      });
    }

    /* Przyklejony pasek zakupu */
    const sticky = $('[data-sticky-atc]', root);
    const mainBtn = $('[data-atc-main]', root);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      const setSticky = (visible) => {
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        $('[data-atc-sticky]', sticky).tabIndex = visible ? 0 : -1;
      };
      new IntersectionObserver(
        ([entry]) => setSticky(!entry.isIntersecting && entry.boundingClientRect.top < 0),
        { threshold: 0 }
      ).observe(mainBtn);
    }
  };

  /* ---------------------------------------------------------------------- *
   * Inicjalizacja
   * ---------------------------------------------------------------------- */
  document.addEventListener('click', (event) => {
    if (onCartClick(event)) return;
    if (event.target.closest('[data-menu-toggle]')) {
      const menu = $('[data-mobile-menu]');
      setMenu(!(menu && menu.classList.contains('is-open')));
      return;
    }
    if (event.target.closest('[data-search-toggle]')) toggleSearch();
  });

  document.addEventListener('change', onCartInputChange);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    setDrawer(false);
    setMenu(false);
  });

  const init = () => {
    initAnnouncement();
    $$('[data-product-section]').forEach(initProduct);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Edytor motywu: ponowna inicjalizacja po przeładowaniu sekcji */
  document.addEventListener('shopify:section:load', (event) => {
    $$('[data-product-section]', event.target).forEach(initProduct);
    if (event.target.matches('[data-product-section]')) initProduct(event.target);
  });
})();
